// @flow
import * as React from 'react';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';
import { format } from 'date-fns';

// Utils
import { toCapitalize } from 'utils/string';

// Components
import DatePicker from 'react-mobile-datepicker';
import { Icon } from 'components/atoms/Icon/';

import './MobileDatePicker.scss';

// Constants
import { getDateFormat, getLocale } from 'constants/date';

const ns = 'mobile-date-picker';

const iOSTheme = 'ios';

type Props = {
  locale: string,
  languageCode: string,
  intl: IntlShape,
  onChange: (date: Date) => void,
  value: string,
  minDate: Date,
  defaultDate: Date
};

type State = {
  isOpenMobileDatePicker: boolean
};

class MobileDatePicker extends React.Component<Props, State> {
  state = {
    isOpenMobileDatePicker: false
  };

  handleClick = () => {
    this.setState({ isOpenMobileDatePicker: true });
  };

  handleCancel = () => {
    this.setState({ isOpenMobileDatePicker: false });
  };

  handleSelectDate = (date: Date) => {
    this.props.onChange(date);
    this.setState({ isOpenMobileDatePicker: false });
  };

  getConfig = () => {
    const monthMap = this.getMonthMap();

    return {
      month: {
        format: (value: Object) => monthMap[value.getMonth() + 1]
      },
      date: {
        format: 'D'
      },
      year: {
        format: 'YYYY'
      }
    };
  };

  getMonthMap = () => {
    const monthMap = {};
    let i = 0;

    for (i; i < 12; i++) {
      monthMap[i + 1] = format(new Date(0, i, 1), 'MMMM', {
        locale: getLocale(this.props.languageCode)
      });
    }

    return monthMap;
  };

  render() {
    const { intl, minDate, value, locale, languageCode } = this.props;
    const { isOpenMobileDatePicker } = this.state;
    const mobileDateConfig = this.getConfig();
    const buttonText = format(value, getDateFormat(locale), {
      locale: getLocale(languageCode)
    });

    return (
      <div className={ns}>
        <button className="select-btn" onClick={this.handleClick}>
          <Icon type="calendar" /> {buttonText}
        </button>
        <DatePicker
          value={value}
          isOpen={isOpenMobileDatePicker}
          onSelect={this.handleSelectDate}
          onCancel={this.handleCancel}
          confirmText={intl.formatMessage({ id: 'c8.vehicle.page.done' })}
          cancelText={toCapitalize(
            intl.formatMessage({ id: 'c8.common.cancel' })
          )}
          dateConfig={mobileDateConfig}
          showHeader={false}
          min={minDate}
          max={new Date()}
          theme={iOSTheme}
        />
      </div>
    );
  }
}

export default MobileDatePicker;



// WEBPACK FOOTER //
// ./src/components/atoms/MobileDatePicker/MobileDatePicker.js